export default {
  index: {
    title: '青岛医疗预约',
    banner: {
      smartMedical: '智慧医疗',
      convenientService: '便捷预约，优质服务',
      specializedMedical: '特色诊疗',
      crossBorder: '中医特色，跨境医疗'
    },
    quickEntry: {
      CaseDetails: '上报案例',
      caseindex: '我的上报',
      transfer: '转运登记',
      CaseProgress: '案例进展',
      investigate: '审查记录',
      appointment: '预约挂号',
      vaccine: '疫苗接种',
      records: '就医记录',
      department: '科室导航'
    },
    news: {
      title: '进修资讯',
      vaccine: '中国器官捐献发展现状',
      cooperation: '人体器官移植技术临床应用管理规定'
    },
    featured: {
      title: '大湾区特色医疗',
      tcm: '中医特色诊疗',
      tcmDesc: '传统中医，现代科技',
      crossBorder: '跨境医疗服务',
      crossBorderDesc: '便捷通关，无缝衔接',
      expert: '专家门诊',
      expertDesc: '名医汇聚，专业诊疗'
    }
  },
  tabbar: {
    home: '首页',
    appointment: '预约',
    my: '我的'
  },
  common: {
    confirm: '确认',
    cancel: '取消',
    loading: '加载中...',
    more: '更多',
    viewAll: '全部',
    viewMore: '查看更多',
    search: {
      placeholder: '搜索科室/医生/疾病'
    },
    language: {
      select: '选择语言'
    },
    tag: {
      new: '最新'
    },
    status: {
      available: '可预约',
      busy: '较忙',
      full: '已满'
    },
    unit: {
      person: '人',
      km: '公里',
      score: '分'
    }
  },
  appointment: {
    title: '预约挂号',
    search: {
      placeholder: '搜索科室/医生/疾病'
    },
    schedule: {
      title: '选择就诊时间',
      date: '选择日期',
      time: '选择时间',
      patient: '选择就诊人',
      addPatient: '添加就诊人',
      fee: '就诊费用',
      submit: '确认预约'
    },
    hospital: {
      title: '选择医院'
    },
    department: {
      title: '选择科室'
    },
    doctor: {
      title: '选择医生'
    },
    type: {
      normal: '普通门诊',
      expert: '专家门诊',
      emergency: '急诊'
    },
    available: '可预约',
    book: '预约'
  },
  my: {
    title: '个人中心'
  },
  department: {
    title: '科室导航',
    search: {
      tabs: {
        department: '科室',
        doctor: '医生',
        disease: '疾病'
      },
      result: {
        doctorCount: '{count}位医生',
        rating: '评分',
        distance: '距离',
        book: '预约挂号'
      }
    },
    category: {
      all: '全部科室',
      internal: '内科',
      surgery: '外科',
      pediatrics: '儿科',
      gynecology: '妇产科',
      ent: '五官科',
      tcm: '中医科'
    }
  },
  doctor: {
    detail: '医生详情'
  },
  vaccine: {
    title: '疫苗接种',
    search: {
      placeholder: '搜索疫苗名称'
    },
    category: {
      all: '全部',
      covid: '冠状病毒疫苗',
      flu: '流感疫苗',
      hpv: 'HPV疫苗',
      child: '儿童疫苗'
    },
    tag: {
      free: '免费',
      recommended: '推荐',
      seasonal: '季节性'
    },
    free: '免费',
    book: '立即预约',
    detail: {
      title: '疫苗详情',
      description: '疫苗说明',
      suitable: '适用人群',
      notice: '注意事项',
      price: '接种费用'
    },
    list: {
      covid: {
        name: '冠状病毒疫苗',
        desc: '预防冠状病毒感染',
        fullDesc: '本疫苗用于预防由冠状病毒引起的感染性疾病...',
        suitable: '18岁以上健康人群',
        notice: '接种前请确保身体状况良好，无发热等症状...'
      },
      flu: {
        name: '流感疫苗',
        desc: '预防季节性流感',
        fullDesc: '本疫苗用于预防流行性感冒...',
        suitable: '6个月以上人群',
        notice: '有发热症状者暂缓接种...'
      },
      hpv: {
        name: 'HPV疫苗',
        desc: '预防宫颈癌等疾病',
        fullDesc: '本疫苗用于预防人乳头瘤病毒感染...',
        suitable: '9-45岁女性',
        notice: '需要完成全程接种才能获得理想保护效果...'
      }
    }
  },
  records: {
    medical: '就医记录'
  }
} 